<template>
    <div></div>
</template>

<script>
    import {getQueryVariable} from "../utils/utils";
    import Cookies from 'js-cookie'
    import axios from 'axios'
    export default {
        name: "blank.vue",
        created() {
            const code = getQueryVariable('code') ? getQueryVariable('code') : ''
            const userId1000122 = Cookies.get('userId1000122') ?  Cookies.get('userId1000122') : ''
            const date1000122 = Cookies.get('date1000122') ? Cookies.get('date1000122') : ''
            console.log('111', code, userId1000122, date1000122)
            if (!userId1000122) {
              if (code) {
                axios.get(`http://dailyreport.uu1.com/apis/wx_qy/query_user?code=${code}&agentid=1000122`).then((res) => {
                  Cookies.set('userId1000122', res.data.id, { expires: 14 })
                  Cookies.set('userNumber1000122', res.data.number, { expires: 14 })
                  Cookies.set('userCompanyId1000122', res.data.id, { expires: 14 })
                  if(date1000122){
                      window.location.href = "http://interview.uu1.com/performance/#/index?date=" + date1000122
                  }else{
                      window.location.href="http://interview.uu1.com/performance/#/index"
                  }
                }).catch((err) => {
                    console.log('网络异常', err)
                  // reject()
                  // alert(err)
                })
              } else {
                this.$toast('参数异常 请稍后再试')
                return false
              }
            }else{
                window.location.href="http://interview.uu1.com/performance/#/index"
            }
        }
    }
</script>

<style scoped>

</style>
